/* Goldgums® thema-gedrag: header, reveal, tabs, shopfilters, product en Ajax-winkelwagen. */
(() => {
  document.documentElement.classList.add('gg-js');
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* Header: glas na scrollen, licht bij hover op logo */
  const header = $('[data-gg-header]');
  if (header) {
    let active = false;
    const paint = () => {
      const scrolled = window.scrollY > 16;
      header.classList.toggle('is-scrolled', scrolled);
      header.classList.toggle('is-active', active);
      header.classList.toggle('is-light', active || scrolled);
    };
    const logo = $('[data-gg-logo]', header);
    if (logo) {
      ['mouseenter', 'focus'].forEach((e) => logo.addEventListener(e, () => { active = true; paint(); }));
      ['mouseleave', 'blur'].forEach((e) => logo.addEventListener(e, () => { active = false; paint(); }));
    }
    window.addEventListener('scroll', paint, { passive: true });
    paint();
  }

  /* Mobiel menu */
  const menu = $('[data-gg-mobile-menu]');
  const openBtn = $('[data-gg-menu-open]');
  if (menu && openBtn) {
    const setMenu = (open) => {
      menu.classList.toggle('is-open', open);
      openBtn.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) $('[data-gg-menu-close]', menu)?.focus(); else openBtn.focus();
    };
    openBtn.addEventListener('click', () => setMenu(true));
    $('[data-gg-menu-close]', menu)?.addEventListener('click', () => setMenu(false));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && menu.classList.contains('is-open')) setMenu(false); });
  }

  /* Reveal: IntersectionObserver plus scrollcontrole zodat niets leeg blijft na een snelle sprong */
  const reveals = $$('.gg-reveal');
  const show = (el) => el.classList.add('is-in');
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    reveals.forEach(show);
  } else {
    const io = new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } }), { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
    reveals.forEach((el) => io.observe(el));
    let raf = 0;
    const check = () => { raf = 0; reveals.forEach((el) => { if (!el.classList.contains('is-in') && el.getBoundingClientRect().top < innerHeight * 0.92) show(el); }); };
    addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(check); }, { passive: true });
    check();
  }

  /* Behoefte-tabs op de home */
  $$('[data-gg-tabs]').forEach((root) => {
    const tabs = $$('.gg-tab', root);
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
      const goal = tab.dataset.goal;
      $$('.gg-rail__item', root).forEach((item) => {
        const g = $('[data-goal]', item)?.dataset.goal;
        item.hidden = Boolean(goal) && g !== goal;
      });
      const rail = $('.gg-rail', root); if (rail) rail.scrollLeft = 0;
    }));
  });

  /* Shop: doelfilters (client-side) en sortering (Shopify sort_by) */
  $$('[data-gg-shop]').forEach((root) => {
    const boxes = $$('[data-gg-filter]', root);
    const cards = $$('[data-gg-grid] > .gg-card', root);
    const chips = $('[data-gg-chips]', root);
    const apply = (source) => {
      if (source) boxes.filter((b) => b.value === source.value).forEach((b) => { b.checked = source.checked; });
      const goals = [...new Set(boxes.filter((b) => b.checked).map((b) => b.value))];
      let visible = 0;
      cards.forEach((c) => { const on = !goals.length || goals.includes(c.dataset.goal); c.hidden = !on; if (on) visible++; });
      $$('[data-gg-visible]', root).forEach((el) => { el.textContent = visible; });
      const cnt = $('[data-gg-filter-count]', root); if (cnt) cnt.textContent = goals.length ? ` (${goals.length})` : '';
      $('[data-gg-empty]', root).hidden = visible > 0;
      chips.innerHTML = '';
      goals.forEach((g) => {
        const label = boxes.find((b) => b.value === g)?.nextElementSibling?.textContent || g;
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'gg-chip'; b.textContent = label + ' ';
        b.insertAdjacentHTML('beforeend', '<svg class="gg-i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>');
        b.setAttribute('aria-label', `Filter ${label} verwijderen`);
        b.addEventListener('click', () => { boxes.filter((x) => x.value === g).forEach((x) => { x.checked = false; }); apply(); });
        chips.appendChild(b);
      });
      if (goals.length) {
        const clr = document.createElement('button');
        clr.type = 'button'; clr.className = 'gg-clear'; clr.textContent = 'Filters wissen';
        clr.addEventListener('click', clear); chips.appendChild(clr);
      }
    };
    const clear = () => { boxes.forEach((b) => { b.checked = false; }); apply(); };
    boxes.forEach((b) => b.addEventListener('change', () => apply(b)));
    $$('[data-gg-filter-clear]', root).forEach((b) => b.addEventListener('click', clear));
    const drawer = $('[data-gg-filter-drawer]', root);
    $('[data-gg-filter-open]', root)?.addEventListener('click', () => drawer.classList.add('is-open'));
    $$('[data-gg-filter-close]', root).forEach((b) => b.addEventListener('click', () => drawer.classList.remove('is-open')));
    $('[data-gg-sort]', root)?.addEventListener('change', (e) => {
      const url = new URL(location.href); url.searchParams.set('sort_by', e.target.value); location.href = url.toString();
    });
  });

  /* Productpagina: galerij, variant, aankoopoptie, aantal */
  $$('[data-gg-pdp]').forEach((root) => {
    const data = JSON.parse($('[data-gg-product-json]', root)?.textContent || '{"variants":[]}');
    const idInput = $('[data-gg-variant-id]', root);
    const planInput = $('[data-gg-selling-plan]', root);
    const mainImg = $('[data-gg-main-img]', root);
    const addBtns = [$('[data-gg-add-btn]', root), $('.gg-stickybar button', root)].filter(Boolean);

    $$('[data-gg-thumb]', root).forEach((t) => t.addEventListener('click', () => {
      $$('[data-gg-thumb]', root).forEach((x) => x.setAttribute('aria-current', String(x === t)));
      if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = t.dataset.src; }
    }));

    const current = () => data.variants.find((v) => String(v.id) === idInput.value) || data.variants[0];
    const render = () => {
      const v = current(); if (!v) return;
      const plan = planInput?.value || '';
      const price = plan && v.plans[plan] ? v.plans[plan] : v.price;
      const pe = $('[data-gg-price] b', root); if (pe) pe.textContent = price;
      const once = $('[data-gg-once-price]', root); if (once) once.textContent = v.price;
      $$('[data-gg-purchase-opt]', root).forEach((opt) => {
        const sel = $('[data-gg-plan-select]', opt); const pp = $('[data-gg-plan-price]', opt);
        if (sel && pp) pp.textContent = v.plans[sel.value] || '';
      });
      const sp = $('[data-gg-sticky-price]', root); if (sp) sp.textContent = price;
      const sm = $('[data-gg-sticky-mode]', root); if (sm) sm.textContent = plan ? 'Abonnement' : 'Eenmalig';
      addBtns.forEach((b) => { b.disabled = !v.available; });
      const main = $('[data-gg-add-btn]', root); if (main) main.textContent = v.available ? 'Toevoegen aan winkelwagen' : 'Uitverkocht';
    };
    $$('[data-gg-variant]', root).forEach((r) => r.addEventListener('change', () => {
      idInput.value = r.value;
      const v = current(); if (v?.image && mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = v.image; }
      render();
    }));
    $$('[data-gg-purchase-opt]', root).forEach((opt) => {
      const radio = $('[data-gg-purchase]', opt); const sel = $('[data-gg-plan-select]', opt);
      const choose = () => {
        $$('[data-gg-purchase-opt]', root).forEach((o) => { o.classList.toggle('is-active', o === opt); const s = $('[data-gg-plan-select]', o); if (s) s.hidden = o !== opt; });
        if (planInput) planInput.value = sel ? sel.value : '';
        render();
      };
      radio?.addEventListener('change', choose);
      sel?.addEventListener('change', () => { if (radio.checked && planInput) planInput.value = sel.value; render(); });
    });
    $$('[data-gg-qty]', root).forEach((b) => b.addEventListener('click', () => {
      const input = $('input[name="quantity"]', b.parentElement);
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.ggQty, 10));
    }));
    render();
  });

  /* Ajax toevoegen → Dawn cart drawer */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-gg-add]');
    if (!form) return;
    e.preventDefault();
    const btns = [...$$('button[type="submit"]', form), ...(form.id ? $$(`button[form="${form.id}"]`) : [])];
    const err = $('[data-gg-error]', form.closest('[data-gg-pdp]') || form);
    btns.forEach((b) => b.setAttribute('aria-busy', 'true'));
    if (err) err.textContent = '';
    const drawer = document.querySelector('cart-drawer');
    const body = new FormData(form);
    if (!body.get('selling_plan')) body.delete('selling_plan');
    if (drawer && drawer.getSectionsToRender) {
      body.append('sections', drawer.getSectionsToRender().map((s) => s.id));
      body.append('sections_url', location.pathname);
    }
    try {
      const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}`, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body });
      const json = await res.json();
      if (json.status) { if (err) err.textContent = json.description || json.message || 'Toevoegen is niet gelukt.'; return; }
      if (drawer && drawer.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents(json); }
      else location.href = (window.routes && window.routes.cart_url) || '/cart';
    } catch (_) {
      if (err) err.textContent = 'Toevoegen is niet gelukt. Probeer het opnieuw.';
    } finally {
      btns.forEach((b) => b.removeAttribute('aria-busy'));
    }
  });

  /* B2B-formulier: honeypot blokkeert verzenden */
  $$('#gg-b2b-form').forEach((f) => f.addEventListener('submit', (e) => {
    const hp = $('[data-gg-honeypot]', f); if (hp && hp.value) e.preventDefault();
  }));
})();